module.exports = __webpack_public_path__ + "static/level_4.e95d376f.png";